import { Text } from "@mantine/core";
import { memo } from "react";

import styles from "./InputTextLength.module.scss";

const InputTextLength = ({
  currentLength,
  maxLength,
}: {
  currentLength: number;
  maxLength: number;
}) => {
  return (
    <Text className={styles.lengthCount}>
      <span className={currentLength <= maxLength ? styles.ok : styles.over}>
        {currentLength}
      </span>
      /{maxLength}
    </Text>
  );
};

export const InputTextLengthMemo = memo(InputTextLength);
